import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'

import * as routes from '../../routes'
import RegistrationList from './RegistrationList'
import { RootState } from '../../store'
import { DistributionType } from '../../store/program/interfaces'
import StageNavigation from '../shared/StageNavigation'
import { addToast } from '../../store/misc/misc'
import { ToastType } from '../../store/misc/interfaces'
import useValidators from '../../hooks/validators'
import { getRegisteredEvents } from '../../store/events/selectors'
import { EventModal } from '../events/EventDetailModal'
import LoadedViaTokenIndicator from '../shared/LoadedViaTokenIndicator'
import { CustomQuestionToast } from './RegistrationListItem/CustomQuestion'

type RegistrationStageParams = {
  eventId: string
}

const RegistrationStage = () => {
  const navigate = useNavigate()
  const { eventId } = useParams<RegistrationStageParams>()
  const { addValidator, hasValidationErrors } = useValidators()
  const { distribution_type } = useSelector(
    (state: RootState) => state.program.data,
  )
  const dispatch = useDispatch()
  const registeredEvents = useSelector(getRegisteredEvents)

  const { data: program } = useSelector((state: RootState) => state.program)
  const { data: institution } = useSelector((state: RootState) => state.institution)
  const { loadedViaFamilyToken } = useSelector((state: RootState) => state.misc)

  useEffect(() => {
    // Update the document title using the browser API
    document.title = `${program.name}: Anmeldungen anpassen | Feripro ${institution.name}`
  })

  useEffect(() => {
    if (loadedViaFamilyToken) {
      dispatch(
        addToast(CustomQuestionToast)
      )
    }
  }, [loadedViaFamilyToken, dispatch])

  return (
    <>
      {eventId && (
        <EventModal editable={true} eventId={parseInt(eventId)} events={registeredEvents} />
      )}
      <Card>
        <Card.Body>
          <Card.Title>
            <h2 aria-level={1}>
              Anmeldungen anpassen
            </h2>
            <LoadedViaTokenIndicator />
          </Card.Title>
            <div>
              {distribution_type !== DistributionType.INSTANT && (
                <Card.Text>
                  Bitte die gewählten Veranstaltungen in eine Wunsch-Reihenfolge
                  nach Prioritäten bringen.
                </Card.Text>
              )}
              <Card.Text>
                Notwendige Felder sind mit einem * markiert.
              </Card.Text>
            </div>
        </Card.Body>
      </Card>
      <RegistrationList isEditable={true} addValidator={addValidator} />
      <StageNavigation
        backward={{
          text: 'Zurück',
          handler: () => navigate(routes.EVENTS.path),
        }}
        forward={{
          text: routes.PARTICIPANT.longName,
          handler: async () => {
            if (await hasValidationErrors()) {
              dispatch(
                addToast({
                  title: 'Fehler',
                  type: ToastType.Danger,
                  body: 'Bitte die angegebenen Daten nochmal überprüfen.',
                }),
              )
            } else if (registeredEvents.length === 0) {
              dispatch(
                addToast({
                  title: 'Fehler',
                  type: ToastType.Danger,
                  body: 'Mindestens eine Veranstaltung auswählen. Bitte einen Schritt zurück gehen.'
                })
              )
            } else {
              navigate(routes.PARTICIPANT.path)
            }
          },
        }}
      />
    </>
  )
}

export default RegistrationStage
